require('./bootstrap');

import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/inertia-vue3";
import { InertiaProgress } from "@inertiajs/progress";
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
 Bugsnag.releaseStage = 'production';

 Bugsnag.start({
     apiKey: 'eaf39755dca98fefd5a36d58076e6d8d',
     plugins: [new BugsnagPluginVue()],
     notifyReleaseStages: ['production']
 })
  const bugsnagVue = Bugsnag.getPlugin('vue')

InertiaProgress.init();

import Input from '@/Components/Input';
import Button from '@/Components/Button';
import ButtonWhite from '@/Components/ButtonWhite';
import Loader from '@/Components/Loader';

createInertiaApp({
    resolve: (name) => require(`./Pages/${name}`),
    setup({ el, App, props, plugin }) {
        createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(bugsnagVue)
            .mixin({ components: {
                Input,
                Button,
                ButtonWhite,
                Loader
            }})
            .mount(el);
    },
});


import axios from 'axios'
import get from 'lodash/get'

axios.interceptors.response.use(response => response, async err => {
    const status = get(err, 'response.status')

    if (status === 419) {
        Bugsnag.notify(err)
        location.reload()
    }

    return Promise.reject(err)
})

